import endpoints from '@app/src/api/endpoints'
import { useFileDownload } from '@app/src/api/fetchHooks'
import { DateRangeOutlined } from '@mui/icons-material'
import { Box, Link, Stack, Typography } from '@mui/material'
import React from 'react'
import { useIntl } from 'react-intl'
import DateDisplay, { useGetFormattedDate } from './DateDisplay'

type RenderFileDownloadProps = {
  fileName: string
  id: number
  expiresAt?: string | null
  children?: React.ReactNode
  showExpiresAtText?: boolean
}
const RenderFileDownload: React.FC<RenderFileDownloadProps> = ({
  fileName,
  id,
  expiresAt,
  children,
  showExpiresAtText = false,
}) => {
  const { downloadFile } = useFileDownload()
  const { formatValueToDate } = useGetFormattedDate()
  const { formatMessage } = useIntl()

  const handleFileDownload = async (id: number) => {
    await downloadFile(endpoints.fileDownload(id))
  }

  const renderExpiresAt = () => {
    if (!expiresAt) return null

    if (showExpiresAtText) {
      return (
        <Box display="flex" alignItems="flex-end" mr={2}>
          <Typography variant="caption">
            {formatMessage({ id: 'questionnaire.expiresAt' }, { date: <DateDisplay value={expiresAt} /> })}
          </Typography>
        </Box>
      )
    }

    return (
      <Box display="flex" alignItems="center" color={({ palette }) => palette.text.secondary}>
        <DateRangeOutlined fontSize="inherit" color="inherit" />
        <Typography variant="caption" ml={0.5} color="inherit">
          {formatValueToDate({ value: expiresAt })}
        </Typography>
      </Box>
    )
  }

  return (
    <>
      <Stack>
        <Link
          underline="always"
          onClick={() => handleFileDownload(id)}
          sx={{
            cursor: 'pointer',
            '&:hover': { background: 'none' },
            fontWeight: 'normal',
            textDecorationColor: 'currentColor',
          }}
        >
          {fileName}
        </Link>

        {renderExpiresAt()}
      </Stack>

      {children}
    </>
  )
}
export default RenderFileDownload
